export default "__VITE_ASSET__fc5af79c__"